import clsx from 'clsx'
import classes from './RecentForm.module.css'
import { ReactComponent as Won } from '../../assets/won.svg'
import { ReactComponent as Loss } from '../../assets/loss.svg'
import { ReactComponent as Draw } from '../../assets/draw.svg'
import { LastFiveMatches } from '../../teams/api'
import { useMediaQuery } from '@mantine/hooks'

export default function LastFiveComponent({
  last_five,
}: {
  last_five: LastFiveMatches
}) {
  const isMobile = useMediaQuery('(max-width: 800px)')

  return (
    <div className={classes.recentForm}>
      {[...last_five].reverse().map((result, index) => {
        const isLast = index === last_five.length - 1

        if (result === 'win') {
          return (
            <div
              key={index}
              className={clsx(
                classes.recentFormItem,
                { [classes.recentFormItemMobile]: isMobile },
                {
                  [classes.underline_green]: isLast,
                }
              )}
            >
              <Won
                className={clsx(classes.icon, {
                  [classes.iconMobile]: isMobile,
                })}
              />
            </div>
          )
        }

        if (result === 'loss') {
          return (
            <div
              key={index}
              className={clsx(
                classes.recentFormItem,
                { [classes.recentFormItemMobile]: isMobile },
                {
                  [classes.underline_red]: isLast,
                }
              )}
            >
              <Loss
                className={clsx(classes.icon, {
                  [classes.iconMobile]: isMobile,
                })}
              />
            </div>
          )
        }

        return (
          <div
            key={index}
            className={clsx(
              classes.recentFormItem,
              { [classes.recentFormItemMobile]: isMobile },
              {
                [classes.underline_black]: isLast,
              }
            )}
          >
            <Draw
              className={clsx(classes.icon, {
                [classes.iconMobile]: isMobile,
              })}
            />
          </div>
        )
      })}
    </div>
  )
}
